import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { type Edges, SafeAreaView } from 'react-native-safe-area-context';

import { BodyText, Button, IconLink, theme } from '@sg/garnish';

/**
 * Warning message for the bag.
 */
export const BagWarning = (props: BagRewardWarningProps) => {
  const { message, cta, accessibilityLabel, closeAccessibilityLabel, onClose, onCtaPress } = props;

  return (
    <SafeAreaView style={styles.container} edges={SAFE_AREA_EDGES}>
      <IconLink
        name="IconClose"
        palette="muted"
        style={styles.closeCta}
        accessibilityLabel={closeAccessibilityLabel}
        onPress={onClose}
      />

      <BodyText sizeMatch={['24']}>{message}</BodyText>

      <Button
        size="large-wide"
        palette="primaryOutline"
        accessibilityLabel={accessibilityLabel}
        onPress={onCtaPress}
      >
        <BodyText style={styles.ctaColor} sizeMatch={['18']}>
          {cta}
        </BodyText>
      </Button>
    </SafeAreaView>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const SAFE_AREA_EDGES: Edges = Platform.select({
  android: ['bottom'],
  default: [],
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: theme.spacing['10'],
    gap: theme.spacing['6'],
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeCta: {
    width: 40,
    height: 40,
    alignSelf: 'flex-end',
  },
  ctaColor: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BagRewardWarningProps = {
  message: string;
  cta: string;
  accessibilityLabel: string;
  closeAccessibilityLabel: string;
  onClose: () => void;
  onCtaPress: () => void;
};
